import { render, staticRenderFns } from "./FormularioComplementarioQueja.vue?vue&type=template&id=2ca495cb&scoped=true"
import script from "./FormularioComplementarioQueja.vue?vue&type=script&lang=js"
export * from "./FormularioComplementarioQueja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca495cb",
  null
  
)

export default component.exports